import { useState, useCallback } from 'react';

export const useRevealDigits = () => {
  // Global tracking for revealed digits in the challenge
  const [challengeRevealedDigits, setChallengeRevealedDigitsState] = useState([
    false,
    false,
    false,
    false,
  ]);
  const [revealUsedThisRound, setRevealUsedThisRound] = useState(false);

  // Check if all digits have been revealed
  const allDigitsRevealed = useCallback(
    () => challengeRevealedDigits.every((revealed) => revealed === true),
    [challengeRevealedDigits]
  );

  // Mark a digit as revealed for the entire challenge
  const revealDigitForChallenge = useCallback(
    (index: number) => {
      const newChallengeRevealedDigits = [...challengeRevealedDigits];
      newChallengeRevealedDigits[index] = true;
      setChallengeRevealedDigitsState(newChallengeRevealedDigits);
      setRevealUsedThisRound(true);

      return newChallengeRevealedDigits;
    },
    [challengeRevealedDigits]
  );

  // Reset revealed digit state for a new round
  const resetRevealedForRound = useCallback(() => {
    setRevealUsedThisRound(false);
  }, []);

  // Reset all revealed digits (e.g., for a new game)
  const resetAllRevealed = useCallback(() => {
    setChallengeRevealedDigitsState([false, false, false, false]);
    setRevealUsedThisRound(false);
  }, []);

  // Update challenge revealed digits state with explicit boolean conversion
  const updateChallengeRevealedDigits = useCallback((digits: boolean[]) => {
    if (digits.length === 4) {
      // Ensure values are explicitly boolean
      const booleanDigits = digits.map((d) => d === true);

      setChallengeRevealedDigitsState(booleanDigits);
    }
  }, []);

  // Explicitly update revealUsedThisRound with boolean conversion
  const updateRevealUsedThisRound = useCallback((used: boolean) => {
    // Ensure value is explicitly boolean
    const booleanValue = used === true;

    setRevealUsedThisRound(booleanValue);
  }, []);

  return {
    challengeRevealedDigits,
    revealUsedThisRound,
    allDigitsRevealed,
    revealDigitForChallenge,
    resetRevealedForRound,
    resetAllRevealed,
    updateChallengeRevealedDigits,
    updateRevealUsedThisRound,
  };
};

export default useRevealDigits;
